var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"expand":""}},_vm._l((_vm.displayedLayers),function(layer){return _c('wgu-layerlistitem',{key:layer.get('lid'),attrs:{"layer":layer,"mapView":_vm.map.getView(),"showLegends":_vm.showLegends,"showOpacityControls":_vm.showOpacityControls}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }